export const MEDICAL_RECORD_KEY = '_medicalReport';
export const TIPOS_ATENCION = [
  {
    value: 'Presencial (Centro de salud)',
    name: 'PRESENCIAL',
  },
  {
    value: 'Telemedicina',
    name: 'TELEMEDICINA',
  },
  {
    value: 'Visita Domiciliaria',
    name: 'DOMICILIARIA',
  },
];
